var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40530_8452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 4.16666V17.5C14.1667 17.9583 13.7917 18.3333 13.3333 18.3333H6.66668C6.20834 18.3333 5.83334 17.9583 5.83334 17.5V4.16666C5.83334 3.70832 6.20834 3.33332 6.66668 3.33332H8.33334V2.49999C8.33334 2.04166 8.70834 1.66666 9.16668 1.66666H10.8333C11.2917 1.66666 11.6667 2.04166 11.6667 2.49999V3.33332H13.3333C13.7917 3.33332 14.1667 3.70832 14.1667 4.16666ZM12.5 4.99999H7.50001V15H12.5V4.99999Z",
    fill: "#E53935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40530_8452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery25);
export default __webpack_public_path__ + "static/media/Battery25.165b23b346a4f0a7bca500920c18b669.svg";
export { ForwardRef as ReactComponent };